(function($, w, d, undefined) {

  function typewriter() {

    // Globals 
    var self = this, speed;

    function init(element, options) {
            // Set Globals
      var str;
      var indice = 0;

      self.options = $.extend( {}, $.fn.typewriter.options, options );
      $currentElement = $(element);
      elementStr = $currentElement.text().replace(/\s+/g, ' ');
      dataSpeed  = $currentElement.data("speed") || self.options.speed;
      $currentElement.empty();
      var showText = setInterval(
				function(){
					if (indice++ < elementStr.length) {
			      $currentElement.append(elementStr[indice]);
			    }else{
			    	clearInterval(showText);
			    }
				}, dataSpeed);
      // self.animation = setInterval(function(){animate_calification()}, 20);
    }

    
    
    // Metodos publicos
    return {
      init: init
    }
  }

  // Plugin jQuery
  $.fn.typewriter = function(options) {
    return this.each(function () {
    	var writer =  new typewriter();
      writer.init(this, options);
      $.data( this, 'typewriter', writer);
    });
  };

  $.fn.typewriter.options = {
    'speed' : 300
  };

    $('a[data-slide-next]').click(function(e){
    
        var currentSlide = $(this).attr('data-slide-next');
           
        if(!$('#boardFinder__slide'+currentSlide).hasClass('set')) {
            $('#boardFinder__slide'+currentSlide).find('.boardFinder__slide__question').typewriter({
                'speed':50 // default: 300
            });

            $('#boardFinder__slide'+currentSlide).addClass('set');
        }

    })

    $('a[data-slide-prev]').click(function(e){
    
        var currentSlide = $(this).attr('data-slide-prev');
           
        if(!$('#boardFinder__slide'+currentSlide).hasClass('set')) {
            $('#boardFinder__slide'+currentSlide).find('.boardFinder__slide__question').typewriter({
                'speed':50 // default: 300
            });

            $('#boardFinder__slide'+currentSlide).addClass('set');
        }

    })

    if(window.location.hash) {
        var $hash = window.location.hash,
        $currentSlide = $hash[$hash.length -1];
        
        if(!$('#boardFinder__slide' + $currentSlide).hasClass('set')) {
            $('#boardFinder__slide' + $currentSlide).find('.boardFinder__slide__question').typewriter({
                'speed':50 // default: 300
            });

            $('#boardFinder__slide'+ $currentSlide).addClass('set');
        }
    } else {
        $('#boardFinder__slide2').find('.boardFinder__slide__question').typewriter({
            'speed':50 // default: 300
        });

        $('#boardFinder__slide2').addClass('set');
    }

})(jQuery, window, document);


